import NeaseChemicalData from "../../../../src/components/nease-chemical-data.js";
import * as React from 'react';
export default {
  NeaseChemicalData,
  React
};